import React from 'react';
import '../../static/css/styles.css';

class Loading extends React.Component {
  render() {
    return (
      <div className="loader-wrapper"><div className="loader"></div></div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js